export default __webpack_public_path__ + "static/media/filter.e311d0df.svg";